import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import Layout from "@/components/Layout";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";
import { roleHomePath } from "@/lib/constants";

export default function Login() {
  const nav = useNavigate();
  const loc = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Signed in");
      const dest = loc.state?.from?.pathname || roleHomePath(u.role);
      nav(dest, { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto px-6 py-16">
        <div className="mb-8">
          <div className="overline text-slate-500 mb-2">Sign in</div>
          <h1 className="font-display font-bold text-3xl tracking-tight">Welcome back</h1>
          <p className="text-slate-600 mt-2 text-sm">Citizens, DCPs, Additional CP, Municipal Commissioner, Divisional Commissioner, Collector &amp; Commissioner of Police.</p>
        </div>
        <Card className="border border-border/70">
          <CardHeader>
            <CardTitle className="font-display">Login</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={submit} className="space-y-4" data-testid="login-form">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password">Password</Label>
                <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
              </div>
              <Button type="submit" className="w-full" disabled={busy} data-testid="login-submit-btn">
                {busy ? "Signing in..." : "Sign in"}
              </Button>
            </form>
            <div className="mt-6 text-sm text-center text-slate-600">
              New citizen?{" "}
              <Link to="/register" className="text-slate-900 font-medium underline underline-offset-4" data-testid="login-register-link">Register here</Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
